import * as Yup from 'yup';
import Translator from "../services/translate-factory"

export type SeparatedFieldValidationParams = {
    values: Record<string, any>
    fieldNames: string[] // ['course_code', 'course_name', 'course_opened_id']
    baseField: string // base field, example: 'course_code'
    message: string
    createError: (arg: { path: string; message: string }) => any
}

export const splitParts = (value?: string | null) =>
    (value || '').split(';')


// USAGE: 
// validateSeparatedFieldsMatch({
//      values: values,
//      fieldNames: ['course_code', 'course_name', 'course_opened_id'], 
//      baseField: 'course_code', 
//      message: T.t'gen_seperated_fields_must_match', 
//      createError: createError
// })
export const validateSeparatedFieldsMatch = ({
    values,
    fieldNames,
    baseField,
    message,
    createError,
}: SeparatedFieldValidationParams) => {

    if (!values || !values[baseField]) return true

    const expectedLength = splitParts(values[baseField]).length

    for (const field of fieldNames) {
        if (!values[field]) continue
        const parts = splitParts(values[field])
        if (parts.length !== expectedLength) {
            return createError({ path: field, message })
        }
    }

    return true
}

/**
 * @description This validation is used to check if the separated fields match the base field
 * @param baseField - The base field to compare the separated fields against
 * @param T - The translator object
 * @returns A Yup validation object
 */
export const separatedFieldTest = (baseField: string, T: Translator) =>
    Yup.string().test(
        `segment-match-against-${baseField}`,
        T.t('gen_seperated_fields_must_match'),
        function (value) {
            const baseValue = this.parent[baseField];
            const compareValue = value;
            const currentField = this.path;

            if (!baseValue || !compareValue) return true;

            if (checkSeparatedFieldsMatch(baseValue, compareValue)) {
                return this.createError({
                    path: currentField,
                    message: T.t('gen_seperated_fields_must_match'),
                });
            }

            return true;
        }
    );


export const checkValidSeparatedFields = (semicolumnCount?: number, compareValue?: string) => {
    let newString = "";

    if (semicolumnCount) {
        newString = ";".repeat(semicolumnCount - 1);
    }

    return checkSeparatedFieldsMatch(newString, compareValue);
}

export const checkSeparatedFieldsMatch = (baseValue?: string, compareValue?: string) => {

    if (!baseValue || !compareValue) return false;

    const baseParts = splitParts(baseValue);

    const compareParts = splitParts(compareValue);

    const baseLength = baseParts.length;
    const compareLength = compareParts.length;

    const compareHasSeparator = compareValue.includes(';');

    const isSingleSegment = !compareHasSeparator;
    if (!isSingleSegment && compareLength !== baseLength) {
        return true;
    }

    return false;
}